module.exports = __webpack_public_path__ + "static/media/UNILAG2018002-zoomed.d828be7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/Events/UNILAG2018002-zoomed.jpg
// module id = 719
// module chunks = 0